import { createStore } from 'vuex'
import login from './login'
import workbench from './workbench'
import front from './front'

// 创建一个新的 store 实例
export default createStore({
    modules: {
        login,
        workbench,
        front
    }
})

